import shiftReviewApi from '../../api/shiftReview'

const state = {
  reviews: [],
}

// actions
const actions = {
  getForShift ({ dispatch, commit}, shiftId) {
    return new Promise((resolve, reject) => {
      shiftReviewApi.getForShift(shiftId, reviews => {
        commit('setReviews', reviews)
        resolve(reviews);
      },
      error => {
        reject(error);
      })
    })
  },

  create ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftReviewApi.create(params, review => {
        commit('addReview', review);
        resolve(review)
      },
      error => {
        reject(error);
      })
    })
  },
}

const mutations = {
  setReviews (state, reviews) {
    state.reviews = reviews;
  },
  addReview (state, review) {
    state.reviews.push(review);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
